import { API, request } from './http-request'
import { getToken } from './ls'
import { AirtableParagraphs, Filename, TablesInFile } from './types'

export const htmly = (text?: string) => text 
    ? text
        .replace(/<div>/g, '<br>')
        .replace(/<\/div>/g, '')
        .replace(/\n/g, '<br>')
        .replace(/\\n/g, '<br>')
        .replace(/~~(.*?)~~/g, '<s>$1</s>')
        .replace(/\^(.*?)\^/g, '<sup>$1</sup>')
        .replace(/~(.*?)~/g, '<sub>$1</sub>')
        .replace(/_(.*?)_/g, '<i>$1</i>')
        .replace(/\*\*(.*?)\*\*/g, '<b>$1</b>')
    : ''

export async function getParagraphs(options: {
    type?: string
    authKey?: string
    projectId?: string
    enableCache?: boolean
}): Promise<AirtableParagraphs> {
    return request(`${API}/airtable`, 'GET', { 
        token: options.authKey, 
        query: { 
            enableCache: options.enableCache, 
            type: options.type, 
            projectId: options.projectId,
        } 
    })
}

export async function getFileFromParagraphs(token: string, paragraphs: AirtableParagraphs, base64: boolean = true): Promise<string> {
    return request(`${API}/rtf/get-from-paragraphs`, 'POST', { 
        token,
        query: { 
            base64,
        },
        data: JSON.stringify(paragraphs),
        isText: true,
    })
}

export async function checkToken(): Promise<{}> {
    const token = getToken()
    if (!token) throw new Error('No token found')
    return request(`${API}/auth/validate-token`, 'GET', { token })
}

export async function askAI(data: any): Promise<{paragraphs: Array<string>}> {
    const token = getToken()
    return request(`${API}/airtable/llm`, 'POST', { token, data: JSON.stringify(data) })
}

export async function updateParagraph(token: string, data: any): Promise<any> {
    return request(`${API}/airtable`, 'POST', { token, data })
}

export async function parseFiles(token: string, data: any): Promise<Record<Filename, TablesInFile>> {
    return request(`${API}/rtf/parse`, 'POST', { token, data, formData: true })
}
